import { render, staticRenderFns } from "./GlobalPhotoalbumPage.vue?vue&type=template&id=e6e46b5a&scoped=true&"
import script from "./GlobalPhotoalbumPage.vue?vue&type=script&lang=js&"
export * from "./GlobalPhotoalbumPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e46b5a",
  null
  
)

export default component.exports